export const UPLOAD_GIFT_IMAGE = "uploadGiftImage";
export const ADD_GIFT = "addGift";
export const GIFT_LIST = "giftList";
export const GET_META_DATA = "getMetaData";
export const SET_GIFT_DETAILS = "setGiftDetails";
export const PURCHASE_GIFT = "purchaseGift";
export const EDIT_GIFT = "editGift";
export const DELETE_GIFT = "deleteGift";